// src/components/landing/LandingFooter.jsx
import React, { useState, useEffect } from 'react';

const LandingFooter = () => {
  const [currentYear, setCurrentYear] = useState(new Date().getFullYear());

  useEffect(() => {
    setCurrentYear(new Date().getFullYear());
  }, []);

  return (
    <footer className="bg-[--asfi-purple] text-white mt-16">
      <div className="container mx-auto px-4 py-12">
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 xl:grid-cols-4 gap-8">
          {/* Logo and Description */}
          <div>
            <a href="https://asfirj.org/" className="flex items-center mb-4">
              <img 
                src="https://asfirj.org/assets/images/logoIcon/logo.png" 
                alt="ASFI Research Journal" 
                className="h-10 filter grayscale brightness-0 invert"
              />
            </a>
            <p className="text-gray-300 text-sm">
              At ASFIRJ, we prioritize our publishers' expectations. With clear guidance, we ensure effective management and delivery. Join us in upholding excellence in research publishing.
            </p>
          </div>
          
        
          
          {/* About Section */}
          <div>
            <h3 className="text-lg font-semibold mb-4">About</h3>
            <ul className="space-y-2">
              <li>
                <a href="https://asfirj.org/aboutus.html" className="text-gray-300 hover:text-white transition-colors flex items-center">
                  <i className="fas fa-square-full text-xs mr-2" style={{ color: '#f59e0b' }}></i>
                  About Us
                </a>
              </li>
              <li>
                <a href="https://africansciencefrontiers.com/" target="_blank" rel="noopener noreferrer" className="text-gray-300 hover:text-white transition-colors flex items-center">
                  <i className="fas fa-square-full text-xs mr-2" style={{ color: '#f59e0b' }}></i>
                  African Science Frontiers Initiatives
                </a>
              </li>
              <li>
                <a href="https://asfischolar.org/" target="_blank" rel="noopener noreferrer" className="text-gray-300 hover:text-white transition-colors flex items-center">
                  <i className="fas fa-square-full text-xs mr-2" style={{ color: '#f59e0b' }}></i>
                  ASFIScholar
                </a>
              </li>
            </ul>
          </div>
          
          {/* Useful Links Section */}
          <div>
            <h3 className="text-lg font-semibold mb-4">Useful Links</h3>
            <ul className="space-y-2">
              <li>
                <a href="https://asfirj.org/events.html" className="text-gray-300 hover:text-white transition-colors flex items-center">
                  <i className="fas fa-square-full text-xs mr-2" style={{ color: '#f59e0b' }}></i>
                  Events
                </a>
              </li>
              <li>
                <a href="https://asfirj.org/terms.html" className="text-gray-300 hover:text-white transition-colors flex items-center">
                  <i className="fas fa-square-full text-xs mr-2" style={{ color: '#f59e0b' }}></i>
                  Terms &amp; Conditions
                </a>
              </li>
              <li>
                <a href="https://asfirj.org/contact.html" className="text-gray-300 hover:text-white transition-colors flex items-center">
                  <i className="fas fa-square-full text-xs mr-2" style={{ color: '#f59e0b' }}></i>
                  Contact Support
                </a>
              </li>
            </ul>
          </div>
          
       
          
          {/* Contact Information */}
          <div>
            <h3 className="text-lg font-semibold mb-4">Contact Information</h3>
            <div className="space-y-3">
              <div className="flex items-start">
                <i className="las la-phone mt-1 mr-3 text-[--asfi-orange]" style={{ fontSize: '1.25rem' }}></i>
                <p className="text-gray-300">+234(0)-701-436-3223</p>
              </div>
              <div className="flex items-start">
                <i className="far fa-envelope-open mt-1 mr-3 text-[--asfi-orange]" style={{ fontSize: '1.25rem' }}></i>
                <p className="text-gray-300">info@asfirj.org</p>
              </div>
              <div className="flex items-start">
                <i className="fas fa-map-marked-alt mt-1 mr-3 text-[--asfi-orange]" style={{ fontSize: '1.25rem' }}></i>
                <p className="text-gray-300">12 Morin, Lagos State, Nigeria</p>
              </div>
            </div>
          </div>

            {/* Author Section */}
          <div>
            <h3 className="text-lg font-semibold mb-4">Author</h3>
            <ul className="space-y-2">
              <li>
                <a href="#" className="text-gray-300 hover:text-white transition-colors flex items-center">
                  <i className="fas fa-square-full text-xs mr-2" style={{ color: '#f59e0b' }}></i>
                  Print Request
                </a>
              </li>
            </ul>
          </div>
          
          {/* Editor Section */}
          <div>
            <h3 className="text-lg font-semibold mb-4">Editor</h3>
            <ul className="space-y-2">
              <li>
                <a href="https://asfirj.org/editors.html" className="text-gray-300 hover:text-white transition-colors flex items-center">
                  <i className="fas fa-square-full text-xs mr-2" style={{ color: '#f59e0b' }}></i>
                  Editors
                </a>
              </li>
            </ul>
          </div>

             {/* Newsletter Signup */}
          <div>
            <h3 className="text-lg font-semibold mb-4">Newsletter Signup</h3>
            <p className="text-gray-300 text-sm mb-3">
              Signup today for hints, tips and the latest news and updates.
            </p>
            <form className="subscribe-form" onSubmit={(e) => e.preventDefault()}>
              <div className="flex">
                <input 
                  type="email" 
                  name="email" 
                  placeholder="Email *" 
                  required
                  className="flex-1 px-3 py-2 text-gray-700 rounded-l-md focus:outline-none focus:ring-2 focus:ring-[--asfi-orange]"
                />
                <input type="hidden" name="action" value="mailchimpsubscribe" />
                <button 
                  type="submit"
                  className="bg-[--asfi-orange] hover:bg-orange-600 px-4 py-2 rounded-r-md transition-colors flex items-center gap-2"
                >
                  Subscribe <i className="fas fa-paper-plane"></i>
                </button>
              </div>
            </form>
          </div>
        </div>
        
        {/* Google Translate Widget */}
        <div className="border-t border-gray-700 mt-8 pt-8">
          <div id="google_translate_element" className="flex justify-center mb-6"></div>
          
          <div className="text-center text-gray-400 text-sm">
            <p>© <span id="currentYear">{currentYear}</span> <a href="https://asfirj.org/" className="text-gray-400 hover:text-white">ASFI Research Journal</a> All Rights Reserved || VO.</p>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default LandingFooter;